module.exports = __webpack_public_path__ + "static/media/para_bul.fae431ec.ico";